import React from 'react';

const ResultSummary = ({ reportCard = {}, primaryColor = '#1e3a8a' }) => {
  const { percentage, overallGrade, result, totalMarks, obtainedMarks } = reportCard;

  // Don't render if no result data exists at all
  if (!percentage && !overallGrade && !result && !totalMarks && !obtainedMarks) {
    return null;
  }

  return (
    <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '8px', padding: '10px 14px', fontSize: '11px', marginBottom: '16px' }}>
      <div style={{ fontWeight: '700', color: primaryColor, marginBottom: '4px', textTransform: 'uppercase' }}>📊 Overall Result Summary</div>
      <div style={{ color: '#1d4ed8', display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
        {(obtainedMarks !== undefined && obtainedMarks !== null) && <span>Total Score: <strong>{obtainedMarks}{totalMarks ? ` / ${totalMarks}` : ''}</strong></span>}
        {(percentage !== undefined && percentage !== null) && <span>Percentage: <strong>{typeof percentage === 'number' ? percentage.toFixed(2) : parseFloat(percentage || 0).toFixed(2)}%</strong></span>}
        {overallGrade && <span>Overall Grade: <strong>{overallGrade}</strong></span>}
        {result && <span>Status: <strong style={{ color: result === 'PASS' ? '#166534' : '#991b1b', background: result === 'PASS' ? '#dcfce7' : '#fee2e2', padding: '2px 8px', borderRadius: '4px' }}>{result}</strong></span>}
      </div>
    </div>
  );
};

export default ResultSummary;
